export const BAKES = [
  {
    id: "01",
    name: "Mini Basque Cheesecakes",
    tag: "The Signature",
    price: 100,
    desc: "Baked at an intense heat with a rich, ultra-creamy custard-like centre — crustless, rustic and perfectly portioned.",
    img: "/photos/cheesecake.jpg",
    msg: "Hi Zoni's Bakehouse! I'd like to order the Mini Basque Cheesecakes (₹100 each).",
  },
  {
    id: "02",
    name: "Chocochunk Cookie Pies",
    tag: "Cookie Pie",
    price: 180,
    desc: "Packed to the brim with oversized, molten chocolate chunks and baked to golden-brown perfection. Crispy on the edges, gooey in the centre — big enough to share, but you won't want to.",
    img: "/photos/cookies.jpg",
    msg: "Hi Zoni's Bakehouse! I'd like to order the Chocochunk Cookie Pies (₹180 each).",
  },
  {
    id: "03",
    name: "Double Chocochunk Cookie Pies",
    tag: "Double Chocolate",
    price: 200,
    desc: "Double the chocolate, double the obsession — rich, dark and unapologetically decadent.",
    img: "/photos/cooling-racks.jpg",
    msg: "Hi Zoni's Bakehouse! I'd like to order the Double Chocochunk Cookie Pies (₹200 each).",
  },
  {
    id: "04",
    name: "Hazelnut Cookie Pie",
    tag: "The Upgrade",
    price: 220,
    desc: "The ultimate upgrade to a classic combo — our cookie pie packed with toasted, crunchy hazelnuts and massive pools of molten chocolate chunks.",
    img: "/photos/hazelnut-cookie-pie.jpg",
    msg: "Hi Zoni's Bakehouse! I'd like to order the Hazelnut Cookie Pie (₹220).",
  },
];

export const ALSO_BAKED = ["Pave Chocolates", "Olive & Sun-Dried Tomato Focaccia"];
